






import { Component, Vue } from 'vue-property-decorator';
import ForgotpasswordComponent from '@/components/forgotpassword/forgotpassword.component.vue';

@Component({
  components: {
    ForgotpasswordComponent,
  },
})
export default class PasswordLost extends Vue {}
